var map = {
	"./how-to-become-better-with-ui-design.md": [
		7260,
		260
	],
	"./the-truth-about-design.md": [
		1310,
		310
	],
	"./the-ugly-truth-about-design.md": [
		8321,
		321
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2834;
module.exports = webpackAsyncContext;